import React from "react";
import { providerPermissionFields } from "./providersData";
import { InsuranceProviderInterface } from "../../types/provider-types";
import ProviderRow from "./ProviderRow";
import SkeltonProviderRow from "../skelton/SkeltonProviderRow";
import NoItem from "../NoItem";

interface IProviderTable {
  bodyData: InsuranceProviderInterface[];
  isLoading: boolean;
  totalCount?: number;
}

const headerCell =
  "bg-surface uppercase text-light-gray font-semibold text-[10px] tracking-[0.06em] leading-[1.25] py-3 px-1 border-b border-edge align-bottom";

const ProviderTable: React.FC<IProviderTable> = ({ bodyData, isLoading, totalCount }) => {
  return (
    <React.Fragment>
      <div className="overflow-x-auto no-scrollbar -mx-1 px-1">
        <table className="w-full min-w-[980px] table-fixed text-left">
          <colgroup>
            <col className="w-[250px]" />
            {providerPermissionFields.map((field) => (
              <col key={field.id} />
            ))}
            <col className="w-[48px]" />
          </colgroup>
          <thead>
            <tr>
              <th className={`${headerCell} sticky left-0 z-[2] pl-1`}>Insurer</th>
              {providerPermissionFields.map((field) => (
                <th key={field.id} title={field.label} className={`${headerCell} text-center`}>
                  {field.shortLabel}
                </th>
              ))}
              <th className={headerCell}>
                <span className="sr-only">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <SkeltonProviderRow />
            ) : (
              bodyData.map((row) => <ProviderRow row={row} key={row?.id} />)
            )}
          </tbody>
        </table>
      </div>
      {!isLoading && !totalCount && (
        <NoItem title="No Providers Found 🔎" desc="Add a provider to get started 🚀" />
      )}
    </React.Fragment>
  );
};

export default ProviderTable;
